import type { DiTypes } from "@iot-platform/core";

export const webCoreTypes = Object.seal({
    infrastructure: {
        IotApiClient: Symbol.for("IotApiClient"),
    },
    repositories: {
        EventBusRepository: Symbol.for("EventBusRepository"),
        LanguageRepository: Symbol.for("LanguageRepository"),
        ChatbotRepository: Symbol.for("ChatbotRepository"),
    },
} satisfies DiTypes);
